import { ready } from '~/core'

ready('filters', '.filters', (filters) => {
  const toggle = filters.querySelector('.filters-button--toggle')
  const main = filters.querySelector('.filters-main')

  const animate = (el, start, end) => {
    el.animate([{ height: `${start}px` }, { height: `${end}px` }], {
      duration: 250,
      easing: 'ease',
    })
  }

  const open_close = () => {
    let start = main.offsetHeight
    let end = (filters.classList.toggle('is-open'), main.offsetHeight)

    let text = toggle.querySelector('.filters-buttonText')
    let isOpen = filters.classList.contains('is-open')

    text.innerText = isOpen ? text.getAttribute('data-opened') : text.getAttribute('data-closed')

    animate(main, start, end)
  }

  toggle.addEventListener('click', open_close)
})
